/**
 * Company Dropdown Component
 * Handles the dropdown/popover functionality for company selection
 */

class CompanyDropdown {
	private container: HTMLElement;
	private trigger: HTMLElement;
	private panel: HTMLElement;
	private isOpen: boolean;

	constructor(element: HTMLElement) {
		this.container = element;
		this.trigger = element.querySelector('.company-dropdown-trigger') as HTMLElement;
		this.panel = element.querySelector('.company-dropdown-panel') as HTMLElement;
		this.isOpen = false;
		
		this.init();
	}

	private init(): void {
		if (!this.trigger || !this.panel) return;

		// Toggle on trigger click
		this.trigger.addEventListener('click', (e: Event) => {
			e.preventDefault();
			this.toggle();
		});

		// Close when clicking outside
		document.addEventListener('click', (e: Event) => {
			if (this.isOpen && !this.container.contains(e.target as Node)) {
				this.close();
			}
		});

		// Close on Escape key
		document.addEventListener('keydown', (e: KeyboardEvent) => {
			if (e.key === 'Escape' && this.isOpen) {
				this.close();
				this.trigger.focus();
			}
		});

		// Update placeholder when checkboxes change
		const checkboxes = this.panel.querySelectorAll('.company-checkbox-input');
		checkboxes.forEach((checkbox) => {
			checkbox.addEventListener('change', () => this.updatePlaceholder());
		});
	}

	private toggle(): void {
		this.isOpen ? this.close() : this.open();
	}

	private open(): void {
		this.isOpen = true;
		this.container.classList.add('is-open');
		this.trigger.setAttribute('aria-expanded', 'true');
	}

	private close(): void {
		this.isOpen = false;
		this.container.classList.remove('is-open');
		this.trigger.setAttribute('aria-expanded', 'false');
	}

	private updatePlaceholder(): void {
		const selected = Array.from(
			this.panel.querySelectorAll('.company-checkbox-input:checked')
		) as HTMLInputElement[];
		
		const placeholder = this.trigger.querySelector('.company-dropdown-placeholder');
		
		if (placeholder) {
			if (selected.length === 0) {
				placeholder.textContent = 'Ich bin gewechselt zu …';
			} else if (selected.length === 1 && selected[0]) {
				placeholder.textContent = selected[0].value;
			} else {
				placeholder.textContent = `${selected.length} Unternehmen ausgewählt`;
			}
		}
	}
}

// Initialize all company dropdowns
document.addEventListener('DOMContentLoaded', () => {
	const dropdowns = document.querySelectorAll('.company-dropdown-container');
	dropdowns.forEach((dropdown) => new CompanyDropdown(dropdown as HTMLElement));
});

// Re-initialize when Contact Form 7 renders (for AJAX submissions)
document.addEventListener('wpcf7mailsent', () => {
	setTimeout(() => {
		const dropdowns = document.querySelectorAll('.company-dropdown-container');
		dropdowns.forEach((dropdown) => {
			if (!dropdown.classList.contains('initialized')) {
				new CompanyDropdown(dropdown as HTMLElement);
				dropdown.classList.add('initialized');
			}
		});
	}, 100);
});
